import React, { useState, useEffect } from 'react';
import { useFetchPostCommentById } from '@/services/postCommentsCopyService';
import { useFetchSpaceSubtypeRelationshipById } from '@/services/spacesSubtypeRelationshipService';

export const useProductDetails = (id) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: commentsData, commentsError } = useFetchPostCommentById(id);
  const { data: spaceDetailData, spaceDetailError } = useFetchSpaceSubtypeRelationshipById(id);

  useEffect(() => {
    if (!id) return;
    const commentsLoaded = commentsData || commentsError;
    const spaceLoaded = spaceDetailData || spaceDetailError;
    if (spaceLoaded) {
      setIsLoading(false);
    }
    if (!commentsLoaded) {
      console.log('There are no comments');
    }
  }, [commentsData, commentsError, spaceDetailData, spaceDetailError, id]);

  return {
    isLoading,
    commentsData,
    commentsError,
    spaceDetailData,
    spaceDetailError,
  };
};
